import { Alert, Spin } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { getErrorMessage } from "src/common/onError";
import { RemoteData } from "src/common/RemoteData";

import * as styles from "./LoaderBox.module.less";

interface PropsLoaderBox<T> {
  remoteData: RemoteData<T>;
  drawReady(data: T): React.ReactNode;
  drawWait?: () => React.ReactNode;
}

export const LoaderBox = observer(
  <T,>({ remoteData, drawReady, drawWait }: PropsLoaderBox<T>) => (
    <>
      {remoteData.status === "wait" && !remoteData.result && (
        <div className={styles.wait}>
          {drawWait ? drawWait() : <Spin size="large" />}
        </div>
      )}
      {remoteData.status === "wait" && !!remoteData.result && (
        <Spin spinning size="large">
          {drawReady(remoteData.result)}
        </Spin>
      )}
      {remoteData.status === "error" && (
        <>
          <Alert
            type="error"
            {...getErrorMessage(remoteData.error || Error("Ошибка"))}
            showIcon
          />
          <ErrorDetails error={remoteData.error} />
        </>
      )}
      {remoteData.status === "ready" && drawReady(remoteData.result)}
    </>
  ),
);

type PropsErrorDetails = {
  error: unknown;
};

const ErrorDetails: React.FC<PropsErrorDetails> = ({ error }) => {
  const src = error instanceof Error && "cause" in error ? error.cause : null;
  if (!(src instanceof Error)) return null;
  return <pre>{src.message.replace(/\\n/g, "\n")}</pre>;
};
